import { createFileRoute } from '@tanstack/react-router';
import { InvoicesPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/invoices/')({
  component: InvoicesRoute,
});

function InvoicesRoute() {
  const { orgId } = Route.useParams();
  return <InvoicesPage orgId={orgId} />;
}
